import { disneyEspnVS } from './espn/vs-unified';
import { disneyEspnFutbol } from './espn/_unused/futbol.config';
import { disneyEspnRugbyUrba } from './espn/_unused/rugby-urba.config';
import { disneyEspnRugbyUrbaMiniatura } from './espn/rugby-urba-miniatura';
import { disneyAvailableNow } from './available-now';
import { disneyCTV } from './ctv';
import { disneySeasonality } from './seasonality';
import { disneySocialThisMonth } from './proximamente/social-this-month.config';
import { disneyRelated } from './proximamente/related.config';
import { disneySocialTop } from './proximamente/social-top.config';
import { disneyCast } from './proximamente/cast.config';
import { disneyGrid } from './proximamente/grid.config';
import { disneyBinge } from './proximamente/binge.config';
import { disneyBestPlan } from './proximamente/best-plan.config';
import { disneyEspnPlayerVSPlayer } from './espn/player-vs-player';

export const DISNEY_TEMPLATES = [
  disneyAvailableNow,
  disneyCTV,
  disneyEspnVS,
  disneyEspnFutbol,
  disneyEspnRugbyUrba,
  disneyEspnRugbyUrbaMiniatura,
  disneySeasonality,
  disneySocialThisMonth,
  disneyRelated,
  disneySocialTop,
  disneyCast,
  disneyGrid,
  disneyBinge,
  disneyBestPlan,
  disneyEspnPlayerVSPlayer
] as const;

export * from './espn/vs-unified/';
export * from './espn/_unused/futbol.config';
export * from './espn/_unused/rugby-urba.config';
export * from './espn/rugby-urba-miniatura/';
export * from './available-now';
export * from './ctv';
export * from './seasonality';
export * from './proximamente/social-this-month.config';
export * from './proximamente/related.config';
export * from './proximamente/social-top.config';
export * from './proximamente/cast.config';
export * from './proximamente/grid.config';
export * from './proximamente/binge.config';
export * from './proximamente/best-plan.config';
export * from './espn/player-vs-player';
